import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "antd";
import { useTheme } from "../../contexts/ThemeContext";

const { Title, Text } = Typography;

const SettingsPageHeader = ({ title, subtitle, actions, topLeft }) => {
  const { theme } = useTheme();
  const screens = Grid.useBreakpoint();

  const hasHeading = Boolean(title) || Boolean(subtitle) || Boolean(topLeft);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: screens?.xs ? "stretch" : "center",
        flexWrap: "wrap",
        gap: 12,
        padding: "8px 12px",
        marginBottom: 24,
        borderBottom: `1px solid ${theme.border}`,
      }}
    >
      <div style={{ minWidth: screens?.xs ? "100%" : 320 }}>
        {topLeft ? <div style={{ marginBottom: hasHeading ? 8 : 0 }}>{topLeft}</div> : null}
        {title ? (
          <Title
            level={2}
            style={{
              margin: 0,
              fontSize: 28,
              fontWeight: 600,
              color: theme.textSecondary,
              lineHeight: 1.2,
            }}
          >
            {title}
          </Title>
        ) : null}
        {subtitle ? (
          <Text style={{ display: "block", marginTop: 6, fontSize: 16, color: theme.textSecondary }}>
            {subtitle}
          </Text>
        ) : null}
      </div>

      {actions ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: screens?.xs ? "flex-start" : "flex-end",
            gap: 12,
            flexWrap: "wrap",
            width: screens?.xs ? "100%" : "auto",
          }}
        >
          {actions}
        </div>
      ) : null}
    </div>
  );
};

SettingsPageHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  actions: PropTypes.node,
  topLeft: PropTypes.node,
};

export default SettingsPageHeader;

